import {
  FormattedMessage,
  MessageDescriptor,
  defineMessages,
} from 'react-intl';
import styled from 'styled-components';

import { LoadingButton } from 'atoms/buttons/LoadingButton';
import { Horizontal } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';

type Status =
  | 'ARCHIVED'
  | 'ASSIGNED'
  | 'CANCELED'
  | 'CLAIMED'
  | 'COMPLETED'
  | 'READY';
const messages: { [key in Status]?: MessageDescriptor } = defineMessages({
  CANCELED: {
    id: 'MissionStatus.canceled',
    defaultMessage: 'Canceled',
  },
  CLAIMED: {
    id: 'MissionStatus.claimed',
    defaultMessage: 'Claimed',
  },
  COMPLETED: {
    id: 'MissionStatus.completed',
    defaultMessage: 'Claim Now',
  },
});

const Root = styled(Horizontal)`
  padding: var(--half-unit) var(--unit);
  border-radius: var(--double-unit);
`;

type Props = {
  show?: boolean;
  claimable?: boolean;
  onClaim?: () => void;
  loading: boolean;
  status: Status;
};
export const MissionStatus = ({
  show,
  claimable,
  onClaim,
  loading,
  status,
}: Props) => {
  if (!show || !messages[status]) {
    return null;
  }

  return (
    <Root>
      <LoadingButton
        onClick={onClaim}
        color="secondary"
        disabled={!claimable}
        loading={loading}
        size="compact"
      >
        <LabelS>
          <FormattedMessage {...messages[status]} />
        </LabelS>
      </LoadingButton>
    </Root>
  );
};
